(function () {
  'use strict';

  var collection = document.querySelector('[data-cw-collection]');

  if (!collection) {
    return;
  }

  var drawer = collection.querySelector('[data-cw-filter-drawer]');
  var panel = collection.querySelector('[data-cw-filter-panel]');
  var openButtons = collection.querySelectorAll('[data-cw-filter-open]');
  var closeButtons = collection.querySelectorAll('[data-cw-filter-close]');
  var sortForms = collection.querySelectorAll('[data-cw-sort-form]');
  var lastFocusedElement = null;
  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function openDrawer() {
    if (!drawer) {
      return;
    }

    lastFocusedElement = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cw-filter-open');

    openButtons.forEach(function (button) {
      button.setAttribute('aria-expanded', 'true');
    });

    if (panel) {
      panel.focus();
    }
  }

  function closeDrawer() {
    if (!drawer) {
      return;
    }

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cw-filter-open');

    openButtons.forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  openButtons.forEach(function (button) {
    button.addEventListener('click', openDrawer);
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function (event) {
    if (!drawer || !drawer.classList.contains('is-open')) {
      return;
    }

    if (event.key === 'Escape') {
      closeDrawer();
    }

    if (event.key !== 'Tab' || !panel) {
      return;
    }

    var focusableItems = panel.querySelectorAll(focusableSelector);

    if (!focusableItems.length) {
      return;
    }

    var firstItem = focusableItems[0];
    var lastItem = focusableItems[focusableItems.length - 1];

    if (event.shiftKey && document.activeElement === firstItem) {
      event.preventDefault();
      lastItem.focus();
    } else if (!event.shiftKey && document.activeElement === lastItem) {
      event.preventDefault();
      firstItem.focus();
    }
  });

  sortForms.forEach(function (form) {
    var select = form.querySelector('[data-cw-sort-select]');

    if (!select) {
      return;
    }

    select.addEventListener('change', function () {
      form.submit();
    });
  });
})();
